import React from 'react';
import axios from "axios";
import { useState, useEffect, useMemo } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
const UserRole = () => {
    const navigate = useNavigate();
    const { state } = useLocation();
    const [userRoleData, setUserRoleData] = useState([]);
    const [schemeValue, setSchemeValue] = useState("");
    const [schemeData, setSchemeData] = useState([]);
    const [roleNameValue, setRoleNameValue] = useState("")
    const [visibilityValue, setVisibilityValue] = useState("");
    const [flag, setFlag] = useState("");
    const [userRoleCode, setUserRoleCode] = useState("");

    const [userTypeValue, setUserTypeValue] = useState("");
    const [userTypeData, setUserTypeData] = useState([]);
    const [level, setLevel] = useState("")

    useEffect(() => {
       
        fetchData();
    }, []);

    const fetchData = async () => {
        const result = await axios(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/userrole`);
        setUserRoleData(result.data.dataContent);
    };

    useEffect(() => {
        if (state) {
            getUserType()
            setUserRoleCode(state.cropSurveyCode.userRoleCode)
            setRoleNameValue(state.cropSurveyCode.userRoleName)
            setVisibilityValue(state.cropSurveyCode.visibility)
            // setSchemeValue(state.cropSurveyCode.schemeCode)
            setLevel(state.cropSurveyCode.orgLevelCode)
            setUserTypeValue(state.cropSurveyCode.userTypeCode)
        }
    }, [])

   

    function validateUserRole() {
       
        if(level === ""){
            alert("Select Organization Level");
            return;
        } 

        if(userTypeValue === ""){
            alert("Select Any User Level");
            return;
        } 

        if(roleNameValue === ""){
            alert("Enter Role Name Value");
            return;
        } 

        if(level && userTypeValue && roleNameValue) {
            state ? UpdateUserRole() : AddNewUserRole()
        }

    }

    function AddNewUserRole() {
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({
        
            "createdByUC": localStorage.getItem("userCodeGlobal"),
            "schemeCode": 1,
            "userRoleName": roleNameValue,
            "userTypeCode": userTypeValue,
            "orgLevelCode": level
          
        });

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };

        fetch(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/userrole`, requestOptions)
            .then(response => response.text())
            .then((result) => {
                alert(JSON.parse(result).message);
                if (JSON.parse(result).success == true) {
                    setFlag(true);
                    navigate("/usermanagement/userrolelist")
                }

            })
            .catch(error => console.log('error', error));
    }

    function UpdateUserRole() {
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({
            
            "userRoleCode": userRoleCode,
            "modifiedByUC": localStorage.getItem("userCodeGlobal"),
            "schemeCode": 1,
            "userRoleName": roleNameValue,
            "userTypeCode": userTypeValue,
            "orgLevelCode": level,
            "visibility": visibilityValue,
          
        });

        var requestOptions = {
            method: 'PUT',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };

        fetch(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/userrole`, requestOptions)
            .then(response => response.text())
            .then((result) => {
                alert(JSON.parse(result).message);
                if (JSON.parse(result).success == true) {
                    setFlag(true);
                    navigate("/usermanagement/userrolelist")
                }

            })
            .catch(error => console.log('error', error));
    }

    function handleResetForm() {
        setSchemeValue('')
        setRoleNameValue('')
        setVisibilityValue('')
        setLevel('')
        setUserTypeValue('')
    
    }

    function getUserType() {
        const fetchUserType = async () => {
          const result = await axios(
            `${
              process.env.NODE_ENV === "development"
                ? process.env.REACT_APP_DEV_MODE
                : process.env.REACT_APP_PRO_MODE
            }/api/usertype`
          );
          setUserTypeData(result.data.dataContent);
        };
        fetchUserType();
      }

     function handleRoleNameValue(value) {
        const valueFinal = value.replace(/[^a-z0-9 ]/gi, "");
        document.getElementById("roleNameEdit").value = valueFinal;
        setRoleNameValue(valueFinal)
    }

    return (
        <>
           
            <main id="main" className="main">
                <div className="pagetitle">
                    <h1>Add New User Role</h1>
                    <nav>
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">User Management</li>
                            <li className="breadcrumb-item active">Add New User Role</li>
                        </ol>
                    </nav>

                </div>
                <section className="section">
                    <div className="card dashboard">
                        <div className="card-body">
                            
                            <form className="g-3 addNewUser">
                                <div className="row">

                                <div className="col-md-4">
                  <label htmlFor="Department" className="form-label">
                      Organization Level
                    </label>
                    <br/>
                    <div
                      className="form-check form-check-inline"
                      onClick={() => {
                        setLevel("G");
                      }}
                    >
                      <input
                        className="form-check-input"
                        type="radio"
                        name="level"
                        id="inlineRadio1"
                        value="G"
                        checked={level === "G" ? "true" : "" }
                        
                      />
                      <label
                        className="form-check-label"
                        htmlFor="inlineRadio1"
                      >
                        Government
                      </label>
                    </div>
                    <div
                      className="form-check form-check-inline"
                      onClick={() => {
                        setLevel("I");
                      }}
                    >
                      <input
                        className="form-check-input"
                        type="radio"
                        name="level"
                        id="inlineRadio2"
                        value="I"
                        checked={ level === "I" ? "true" : "" }
                      
                      />
                      <label
                        className="form-check-label"
                        htmlFor="inlineRadio2"
                      >
                        Insurance
                      </label>
                    </div>
                  </div>
                 <div className='row'>
                  <div className="col-md-4">
                    <label htmlFor="userType" className="form-label">
                      User Level
                    </label>
                    <select
                      id="userType"
                      required
                      className="form-select"
                      onClick={getUserType}
                      onChange={(e) => setUserTypeValue(e.target.value)}
                      value={userTypeValue}
                    >
                      <option>Choose...</option>
                      {/* {userTypeData.map((item, id) => {
                        return (
                          <option key={id} value={item.userTypeCode}>
                            {" "}
                            {item.userTypeName}
                          </option>
                        );
                      })} */}
                        {level === "G" ?
                       <><option value= "1"> Central Level </option>
                        <option value= "2"> State Level </option>
                        <option value= "3"> District Level </option>
                        <option value= "4"> Block/SubDistrict Level </option>
                        <option value= "5"> Surveyor </option>
                        </>:
                       <> <option value= "2"> State Level </option>
                        <option value= "3"> District Level </option>
                        <option value= "5"> Surveyor </option>
                        </> }
                    </select>
                  </div>
                  </div>

                             
                                  <div className='row'>
                                    <div className="col-md-4">
                                        <label for="State" className="form-label">Role Name</label>
                                        <input className="form-control" type="text" placeholder="Role Name" id="roleNameEdit" onChange={(e) => handleRoleNameValue(e.target.value)} value={roleNameValue} maxLength={50}/>
                                    </div>
                                    </div>

                                    {state && 
                                        <div className="col-md-4">
                                            <label for="Block" className="form-label">Visibility</label>
                                            <select id="Block" className="form-select" onChange={e => setVisibilityValue(e.target.value)} value={visibilityValue}>
                                                <option selected>Choose...</option>
                                                <option value="Yes">Yes</option>
                                                <option value="No">No</option>

                                            </select>
                                        </div>

                                    }

                                    <div className="d-grid gap-2 d-md-flex justify-content-md-center">
                                        {state ? <button className="btn btn-success me-md-2" type="button" onClick={validateUserRole}>Update</button> : <button className="btn btn-success me-md-2" type="button" onClick={validateUserRole}>Save</button> }
                                        <button className="btn btn-outline-primary me-md-2" type="button" onClick={handleResetForm}>Reset</button>
                                        <button className="btn btn-outline-danger me-md-2" type="button" onClick={() => navigate("/usermanagement/userrolelist")}>Cancel</button>
                                    </div>

                                </div>
                            </form>
                        </div>
                    </div>

                    
                </section>
         

            </main>
        
        </>
    )
}

export default UserRole;

